import '../src/lib/publicPath';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/dist/vuetify.min.css';
import '../src/lib/basePackConfig';
import VueMask from 'v-mask';

import store from '../src/store/direct_mail';
import router from '../src/components/direct_mail/DMOfferCodeRouter';
import DMOfferCodeApp from '../src/components/direct_mail/DMOfferCodeApp.vue';

Vue.use(Vuetify);
Vue.use(VueMask);
Vue.use(VueRouter);
Vue.use(VueMeta);
Vue.use(require('vue-faker'));

// eslint-disable-next-line no-new
new Vue({
  store,
  router,
  el: '#dm-offer-code-app',
  vuetify: new Vuetify(),
  render: (h) => h(DMOfferCodeApp),
});
